import { set, isUndefined } from 'lodash/fp';

export default (path, getter) =>
  (acc, ...args) => {
    const value = getter(...args);

    return isUndefined(value) ? acc : set(path, value, acc);
  };
